import { GENERIC_ANALYTICS_URL } from '../../../globals';
interface IAppMetadataInfo {
  iframeId: string;
  origin: string;
  url: string;
}

interface IAppMetaData {
  [x: string]: IAppMetadataInfo;
}

export enum IframeApps {
  GENERIC_ANALYTICS = 'GENERIC_ANALYTICS',
}

export const AppMetadata: IAppMetaData = {
  [IframeApps.GENERIC_ANALYTICS]: {
    iframeId: 'persistent-iframe-generic-analytics',
    origin: GENERIC_ANALYTICS_URL,
    url: GENERIC_ANALYTICS_URL,
  },
};

export enum IncomingActions {
  Loaded = 'LOADED',
  Routing = 'ROUTING'
}

export enum OutgoingActions {
  Routing = 'ROUTING',
  CREDENTIALS_SHARING = 'CREDENTIALS_SHARING',
}
